import { render } from "./RichTextField.vue?vue&type=template&id=3ea395c0&scoped=true"
import script from "./RichTextField.vue?vue&type=script&lang=js"
export * from "./RichTextField.vue?vue&type=script&lang=js"

import "./RichTextField.vue?vue&type=style&index=0&id=3ea395c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea395c0"]])

export default __exports__